import React from "react";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";
import BlogList from "../components/BlogPosts/BlogLists";

const Blogs = () => {
  const seoData = {
    title: "Blogs - Wise Community",
    description:
      "Explore insightful blogs from the Wise Community focusing on women in the semiconductor ecosystem, research, engineering, and leadership.",
    keywords:
      "Wise Community Blogs, Women in Semiconductors, Engineering, Leadership, Research, Technology",
    pathSlug: "blogs",
  };

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      {/* Blog List Section */}

      <BlogList />
    </>
  );
};

export default Blogs;
